var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _line, _line2, _line3, _path8, _ellipse, _rect2, _path9, _path0, _rect3, _line4, _path1, _path10, _rect4, _path11, _rect5, _path12, _path13, _path14, _path15, _path16, _circle, _line5, _line6, _line7, _line8, _path17, _line9, _line0, _path18, _path19, _path20, _path21, _path22, _path23, _polygon, _path24, _polyline, _path25, _path26, _path27, _polyline2, _path28, _path29, _path30, _rect6, _polygon2, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _polygon3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _rect7, _rect8, _path52, _path53, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _polygon11, _polygon12, _line21, _line22, _polygon13, _line23, _polygon14, _line24, _line25, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _line26, _line27, _line28, _line29, _rect9, _rect0, _rect1, _rect10, _rect11, _path61, _path62, _line30, _path63, _line31, _line32, _path64, _path65, _path66, _rect12, _path67, _circle2, _circle3, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _line33, _line34, _line35, _line36, _line37, _line38, _polygon20, _path78, _path79, _path80, _path81, _rect13, _rect14, _path82, _path83, _path84, _path85, _line39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUni(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M321.1,51a35.2,35.2,0,1,1-24.9,10.31A35.09,35.09,0,0,1,321.1,51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M373.22,332.12h-91m-13.9,0H253.77m-15.09,0H218.81m-3.23,0H196.9m-8.61,0H158.67m-7.88,0H130.71m.82,9.36h68.94m31.56,0h4m20.32,0h99.26m9.38,0h17.3m14.52,0h7.06a1.78,1.78,0,0,0,1.77-1.77V333.9a1.78,1.78,0,0,0-1.77-1.78h-5.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M93.17,135.07v31.54H91.6V135.07h1.57Zm0-2.67,1.1-1.11v1.11l-.07.06-.06.07-.06.07-.06.07-.06.07,0,.07-.06.08-.05.07,0,.08,0,.08,0,.08,0,.08,0,.08,0,.08,0,.08,0,.09,0,.08,0,.09,0,.09,0,.08,0,.09,0,.09,0,.09,0,.1,0,.09,0,.09v.57H91.6v-.68l0-.13,0-.13,0-.13,0-.13,0-.13,0-.13,0-.12,0-.13.05-.12,0-.13,0-.12,0-.11,0-.12.06-.12.06-.11.07-.12.06-.11.07-.11.07-.1.07-.11.08-.1.08-.11.08-.1.08-.1.09-.09.09-.1.09-.09v1.11Zm1.1-1.11.56.56-.55.55v-1.11Zm0,0h0l-1.1,1.11h0v-1.11Zm-1.11,1.11-.55-.56.55-.55v1.11ZM97,129.72v1.56h-.48l-.1,0h-.09l-.09,0-.1,0-.09,0-.09,0-.09,0-.09,0-.08,0-.09,0-.09,0-.08,0-.08,0-.08,0-.09,0-.08,0-.07,0-.08,0-.08.05-.07,0-.08.06-.07.05-.07.06-.07.06-.07.06-.06.06-.07.07-1.11-1.11.09-.09.1-.09.1-.09.09-.08.1-.08.1-.08.11-.07.1-.08.11-.07.11-.07.11-.06.12-.07.11-.06.12-.05.11-.06.12-.05.12,0,.13-.05.12,0,.13,0,.12,0,.13,0,.13,0,.13,0,.13,0,.13,0,.14,0,.13,0H97Zm296.28,1.56H97v-1.56H393.24v1.56Zm2.67,0L397,132.4h-1.11l-.06-.06-.07-.07-.07-.06-.07-.06-.07-.05-.07-.06-.08,0-.07-.06-.08-.05-.08,0-.08,0-.08,0-.08,0-.08,0-.08,0-.09,0-.08,0-.09,0-.09,0-.08,0-.09,0-.09,0-.09,0-.09,0-.1,0h-.09l-.09,0h-.48v-1.56h.54l.14,0,.13,0,.13,0,.13,0,.13,0,.13,0,.13,0,.12,0,.13,0,.12,0,.13.05.12,0,.12.05.11.06.12.06.11.06.12.06.11.07.11.07.1.07.11.07.11.08.1.07.1.09.1.08.09.08.1.09.09.09ZM397,132.4l-.55.55-.56-.55Zm0,0h0l-1.11-1.11H397v1.11Zm-1.1-1.11.55-.56.55.56Zm2.67,3.78H397v-.48l0-.09v-.1l0-.09,0-.09,0-.09,0-.09,0-.09,0-.09,0-.09,0-.09,0-.08,0-.08,0-.09,0-.08,0-.08-.05-.08,0-.08-.05-.08-.05-.07-.05-.08-.06-.07,0-.07-.06-.08-.06-.07-.06-.06-.06-.07-.06-.06,1.1-1.11.09.09.09.09.09.1.08.1.08.1.08.1.07.1.08.11.07.11.07.11.06.11.07.11.06.11.05.12.06.12.05.12.05.12,0,.12,0,.12,0,.13,0,.13,0,.13,0,.12,0,.13,0,.14,0,.13,0,.13,0,.14v.54ZM397,326.48V135.07h1.56V326.48l-.78.79-.78-.79Zm1.56,0v.79h-.78l.78-.79Zm-3.13-.78h2.35v1.57h-2.35V325.7Zm-3.9,0h3.9v1.57h-3.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M390.16,323.54h2V137h-296L96,164.88M129.7,323.54h16.23m1.86,0h15.58m11.75,0h32.15m18.62,0h16.28m6.44,0h15.8m19.75,0h14.61m27,0,46.33-.05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M257.21,340.79H345a3.11,3.11,0,0,1,3.11,3.11v9.74a3.11,3.11,0,0,1-3.11,3.11H143a3.12,3.12,0,0,1-3.11-3.11V343.9a3.11,3.11,0,0,1,3.11-3.11h57.52m31.56,0h4.49"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M195.26,358.37v79.14a10.37,10.37,0,0,1-3.07,7.38l-.09.09a10.43,10.43,0,0,1-7.29,3H166a10.48,10.48,0,0,1-10.45-10.45V358.37a1.57,1.57,0,0,1,1.57-1.57h4.44a1.57,1.57,0,0,1,1.57,1.57v79.14a2.86,2.86,0,0,0,.84,2h0a2.82,2.82,0,0,0,2,.84h18.86a2.87,2.87,0,0,0,2.87-2.87V358.37a1.58,1.58,0,0,1,1.57-1.57h4.44a1.57,1.57,0,0,1,1.57,1.57Zm-1.57,0v79.14a8.9,8.9,0,0,1-8.88,8.88H166a8.9,8.9,0,0,1-8.88-8.88V358.37h4.44v79.14A4.46,4.46,0,0,0,166,442h18.86a4.46,4.46,0,0,0,4.44-4.44V358.37Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M195.26,382.12V408a1.57,1.57,0,0,1-1.57,1.57h-4.44a1.57,1.57,0,0,1-1.57-1.57V382.12a1.57,1.57,0,0,1,1.57-1.56h4.44a1.56,1.56,0,0,1,1.57,1.56Zm-1.57,0V408h-4.44V382.12ZM157.07,408V382.12h4.44V408Zm-1.57,0V382.12a1.56,1.56,0,0,1,1.57-1.56h4.44a1.56,1.56,0,0,1,1.57,1.56V408a1.57,1.57,0,0,1-1.57,1.57h-4.44A1.57,1.57,0,0,1,155.5,408Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.56,
    height: 2.99,
    x: 200.47,
    y: 338.98,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 202.71,
    x2: 202.71,
    y1: 338.98,
    y2: 282.65,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 199.06,
    x2: 212.83,
    y1: 282.41,
    y2: 282.41,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 202.71,
    x2: 211.1,
    y1: 300.46,
    y2: 300.46,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M211.76,302l-.08,7.86c-1.13,4.75-6.42,14.16-1.13,14.16h13.84c5.58,0,0-9.22-1.78-14.16l-.07-7.86Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.15,
    cy: 329.93,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 2,
    ry: 3.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.06,
    height: 2.53,
    x: 242.77,
    y: 307.96,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 1.27
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M243.33,310.49c0,11.16.56,10.59-2,15.57-1.47,2.89-8.69,18.65-3.64,19.21a106.78,106.78,0,0,0,16.87,0c4.91-.58-1.8-15.94-3.43-19.27-2.46-5-1.86-4.45-1.91-15.54Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M217.12,281.18c.06-3.2.75-6.1,2.31-8,3.94-4.71,11.36-3.95,13.9.89a3.56,3.56,0,0,1-1.14,4.62c-3.73,2.73-7.23-3.26-3.05-5.42,7.07-3.65,15.86,8.83,11,13.74-2.22,2.22-6.68-.87-4.93-3.66,2.22-3.54,6.29-2,8.27,0,4,4,4.75,13.83-.74,14.78a2.94,2.94,0,0,1-2.87-4.4c1.17-2.44,5.57-2.62,7.39,1.08,1.55,3.13.5,10.17-1.37,13.13"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 2.37,
    x: 213.4,
    y: 281.23,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 0.89
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 217.15,
    x2: 217.15,
    y1: 329.93,
    y2: 334.92,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M217,283.91q-1.89,3.79-3.8,7.59c-.75,1.51-.45,2,1.39,2h5.32c1.54,0,1.82-.62,1.12-1.94Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M278.43,315a10.13,10.13,0,1,1-6.34,0V292.87h6.34Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.76,
    height: 4.49,
    x: 270.38,
    y: 288.38,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 1.78
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M318.71,305.08a15,15,0,1,1-11.54,0V275.33h11.54v29.75Zm-1.57,1.08a13.43,13.43,0,1,1-8.4,0V276.9h8.4Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12.93,
    height: 5.95,
    x: 306.47,
    y: 270.95,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 2.22
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M345.66,73.85a27.5,27.5,0,1,0,1.56,21A27.41,27.41,0,0,0,345.66,73.85Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M154.71,330.47a5.22,5.22,0,1,1-5.22,5.22A5.22,5.22,0,0,1,154.71,330.47Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M160.67,293.11a4.56,4.56,0,1,1-4.56,4.56A4.56,4.56,0,0,1,160.67,293.11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M170.15,310.61a7.14,7.14,0,1,1-7.13,7.14A7.14,7.14,0,0,1,170.15,310.61Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M187,302.47a3.68,3.68,0,1,1-3.68,3.68A3.67,3.67,0,0,1,187,302.47Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.58,
    cy: 331.06,
    r: 4.41,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 161.7,
    x2: 166.28,
    y1: 299.73,
    y2: 311.76,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 186.26,
    x2: 176.85,
    y1: 307.01,
    y2: 314.14,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 156.62,
    x2: 166.92,
    y1: 332.38,
    y2: 321.5,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 191.04,
    x2: 176.34,
    y1: 329.74,
    y2: 321.3,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M177.5,332.24a4.41,4.41,0,1,1-4.41,4.41A4.41,4.41,0,0,1,177.5,332.24Z"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 172.23,
    x2: 176.33,
    y1: 324.57,
    y2: 334.22,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 163.02,
    x2: 149.69,
    y1: 317.75,
    y2: 318.8,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M146.86,314.19a4.72,4.72,0,1,1-4.72,4.72A4.72,4.72,0,0,1,146.86,314.19Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M57.38,447.36s2.39,1.91,10.22,1.58c6.14-.25,13.38-2,18.61-5.36l-.41-5.41a6.18,6.18,0,0,1-.24,2.08c-.87,2.38-7.16,4.24-11.56,5.15-6.25,1.29-14.88,1.46-16.15-.28a6.73,6.73,0,0,1-.37-1.06,7,7,0,0,1-.17-.91l-.28,0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M100.63,352.29,97.92,431h12l13.82-78.92a59,59,0,0,1-16.34.75c-.72-4.76-2-10.81-2.7-15.57l-3.27,14.88C101.14,352.19,100.89,352.25,100.63,352.29Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M70.07,350.9l-.28,81,15.2.23,14.33-79.59C89.77,354.09,79.87,353.06,70.07,350.9Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M108.9,223.34l-.55-3.51a40.93,40.93,0,0,1-12.55-2.08L94.62,224"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M128.39,311.42c.84,7.68,1.68,15.46,2.51,23.49-.29-.18-.61-.42-1-.73l-6.38-5c-1.36-1.06-1.93-1.2-2-2.9l-.81-14.09Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "128.39 311.42 128.9 316.15 120.93 316.84 120.67 312.18 128.39 311.42"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M94.91,224c4.17,1.13,10.7,1.39,14-.87m.16,6.52-5.31-3.43L102,228l-3.15,3.15"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "108.75 238.09 105.8 231.25 103.38 231.34 102.43 240.33"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M123.13,203.51c.05,2.53,1.61,3.28,1.74,6.1.6,13.54-25.71,11.14-33.48,6.08.6-.29,1.85-1.24,3.49-4.43,2.31-4.52.66-7.64.66-7.64-.57,1.18-1.94,1.24-3.07.95-3.53-.91-4.88-6.89-2.67-9.52,1.77-2.09,4.86.66,4.86.66,3.24-2.33,4.51-3.85,7.47-6.83,5.28,5.33,18.33,8.45,21.76,5.85A45.8,45.8,0,0,0,123.13,203.51Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M113,204.42c1.52-1.4,4.46-1.1,4.14,1.36"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M111.91,222.7l-3,.42c0,.22,1.25,18.78-2.46,25.21-3.7-4.59-6.83-18.29-11.58-24.34l-3.29-.13-1.2,10.8,7,3.8-2.73,5.45,12.14,13.21L114.64,240l-3.07-2.6,3.73-3.31Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "104.62 337.71 106.81 257.12 106.38 247.64"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M148.45,208.52c2.36,3.51,8.71,11,8.79,13.46.19,5.83-23.68,5.91-23.43.06.11-2.61,5.95-9.59,8.75-13.67v-1.86m0-12.4v-1.67h5.89V195"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M131.24,241.76l5.6-3.9s-.8,0-.2-2.3,4-3.78,3.25-5.36,2.42-3.35,3.22-.5a7.34,7.34,0,0,1-.67,5.3,22,22,0,0,0,7.09-.76c3.6-1.05,4.47-3.82,6.83-1.83,1.85,1.57,2.39,5.59,2,8-.72,5.05-15.24,6.69-19.51,4.88l-2.63,3.24"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M149.43,195a15.8,15.8,0,0,1-6.54-.91c-4.83-1.82-7.16,14,3.73,13.22.64-.05,1.15-.08,1.61-.14a11,11,0,0,0,3.94-1.35l.94,3.32,7.29-3.34c-2.43-4.7-4.35-8.09-6.57-12.8-.9-1.91-2-1.83-4.3-1.45l-.05,2.66a.5.5,0,0,1,.7-.05C151.09,194.72,150.3,194.82,149.43,195Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.48,
    height: 4.24,
    x: 141.92,
    y: 188.56,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 0.53
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "103.39 231.72 102.16 228.45 103.85 226.71 106.33 228.32 105.93 231.65 103.39 231.72"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M83.88,176.43a2.25,2.25,0,0,0,0,.29S83.9,176.61,83.88,176.43Zm0,0c-.12-1-.64-4.28-2.23-3.29-1.88,1.15-.33,3.75-.33,3.75s-2.59.3-3.39,1.57,2,.82,2,.82C68.85,189.7,79.49,213.66,91,215.81c0,0,1.56,0,3.88-4.55s.66-7.64.66-7.64c-.57,1.18-1.94,1.24-3.07.95-3.53-.91-4.88-6.89-2.67-9.52,1.77-2.09,4.86.66,4.86.66,3.24-2.33,4.51-3.85,7.47-6.83,6.09,6.15,22.52,8.47,22.6,3.35l0-1.62c4.37,1.45,5.52,1.86,4.9-3.36-2.08-17.31-22.12-29.11-38-20.23-7.46,4.16-7.81,8.3-7.75,9.41Zm29.74,19.17c-4.15-.87-8.55-2.64-11.45-5.09l-.63.64a40.8,40.8,0,0,1-6.13,5.47,1.2,1.2,0,0,1-1.54,0s-2.18-2-3.17-.79a3.3,3.3,0,0,0-.64,1.33,6.19,6.19,0,0,0,.09,3.16,5.22,5.22,0,0,0,1.52,2.57,2.88,2.88,0,0,0,1.09.58,2.59,2.59,0,0,0,1.29,0,.65.65,0,0,0,.41-.32,1.16,1.16,0,0,1,2.1-.1s2,3.66-.64,8.73c-1.87,3.65-3.55,4.73-4.38,5.06a1.32,1.32,0,0,1-.48.13H91l-.21,0a16,16,0,0,1-8.45-5.13,31.75,31.75,0,0,1-6.65-11.35,26.72,26.72,0,0,1-1.25-13.17,16.43,16.43,0,0,1,3-7c-.91-.28-1.46-1-.49-2.51A5.08,5.08,0,0,1,79.72,176a3.25,3.25,0,0,1,1.31-3.9,1.86,1.86,0,0,1,2.78.38c1.08-1.93,3.19-4.26,7.25-6.53a24.75,24.75,0,0,1,9.2-3,26.85,26.85,0,0,1,15.81,3.12,28.9,28.9,0,0,1,11.58,11.31,26.16,26.16,0,0,1,3.17,9.69c.47,3.89,0,5.36-2,5.6a7.35,7.35,0,0,1-2.9-.5v0a3.26,3.26,0,0,1-.54,1.75h0c-.84,1.26-2.59,1.95-4.81,2.15A25,25,0,0,1,113.62,195.6Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M57.85,445.12a6.73,6.73,0,0,1-.37-1.06,5.5,5.5,0,0,1-.06-2.84c.54-1.88,3.38-2.63,5.53-4s6.84-5.3,6.84-5.3l15.2.23s1.34,6,.57,8.13c-.87,2.38-7.16,4.24-11.56,5.15C67.75,446.69,59.12,446.86,57.85,445.12Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M67.09,434.09c1.48-1.18,2.7-2.2,2.7-2.2l11.82.18c-1.9,2.35-5,3.79-7.45,4.72C69.47,438.6,64.64,438.19,67.09,434.09Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M60.21,440.69c3.12-1.19,7.6,0,8.68,3.38"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M116.51,434.34c3.11-.39,5.09-.9,7.24-.2,2.72.89,1.66,5.25,1.45,6.66l-27.3-.27c-.53-2.71-.81-8.33.49-9.53h11.15C111.31,433.23,113.45,434.72,116.51,434.34Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M106.72,431h2.82c1.65,2.09,3.64,3.53,6.4,3.39C114.41,435.36,107.43,435.55,106.72,431Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M97.25,443.68l7.53.11.17-1.72a28.4,28.4,0,0,0,5.88,1.21c2.86.21,14.67-.23,14.67-.23l.16-2.25-28.33-.09Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M73.73,311.91l21,1.47-1.17,14.67c-.12,1.56-.7,1.72-2.07,2.56l-8.8,5.25c-1.76,1.09-2.15.84-3.56-.71l-5.45-6c-1.16-1.27-1.7-1.51-1.51-3.2Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "73.73 311.92 94.74 313.38 94.35 318.28 73.21 316.55 73.73 311.92"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M334.43,358.37v79.14a10.42,10.42,0,0,1-3.07,7.38l-.09.09a10.44,10.44,0,0,1-7.29,3H305.12a10.48,10.48,0,0,1-10.45-10.45V358.37a1.57,1.57,0,0,1,1.57-1.57h4.44a1.58,1.58,0,0,1,1.57,1.57v79.14a2.86,2.86,0,0,0,.84,2h0a2.86,2.86,0,0,0,2,.84H324a2.9,2.9,0,0,0,2-.84,2.86,2.86,0,0,0,.84-2V358.37a1.57,1.57,0,0,1,1.57-1.57h4.44a1.57,1.57,0,0,1,1.57,1.57Zm-1.57,0v79.14a8.9,8.9,0,0,1-8.88,8.88H305.12a8.9,8.9,0,0,1-8.88-8.88V358.37h4.44v79.14a4.46,4.46,0,0,0,4.44,4.44H324a4.46,4.46,0,0,0,4.44-4.44V358.37Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M334.43,382.12V408a1.57,1.57,0,0,1-1.57,1.57h-4.44a1.57,1.57,0,0,1-1.57-1.57V382.12a1.56,1.56,0,0,1,1.57-1.56h4.44a1.56,1.56,0,0,1,1.57,1.56Zm-1.57,0V408h-4.44V382.12ZM296.24,408V382.12h4.44V408Zm-1.57,0V382.12a1.56,1.56,0,0,1,1.57-1.56h4.44a1.57,1.57,0,0,1,1.57,1.56V408a1.57,1.57,0,0,1-1.57,1.57h-4.44A1.57,1.57,0,0,1,294.67,408Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M219.6,304.22a1.22,1.22,0,1,1-1.21,1.22A1.22,1.22,0,0,1,219.6,304.22Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M216.37,306.89a.65.65,0,1,1-.63.65A.64.64,0,0,1,216.37,306.89Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M214.77,304.19a.75.75,0,1,1-.72.75A.73.73,0,0,1,214.77,304.19Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M245.1,330.82a1.31,1.31,0,1,1-1.27,1.3A1.28,1.28,0,0,1,245.1,330.82Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M248.9,336.55a2,2,0,1,1-1.93,2A2,2,0,0,1,248.9,336.55Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M272.59,319.09a2.22,2.22,0,1,1-2.14,2.21A2.18,2.18,0,0,1,272.59,319.09Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M272,328.45a1.12,1.12,0,1,1-1.09,1.12A1.11,1.11,0,0,1,272,328.45Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M309.92,310.18a3.17,3.17,0,1,1-3.07,3.16A3.12,3.12,0,0,1,309.92,310.18Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M313.38,299.87a1.13,1.13,0,0,1,0,2.26,1.13,1.13,0,0,1,0-2.26Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M317.08,316.2a1.13,1.13,0,1,1-1.1,1.13A1.11,1.11,0,0,1,317.08,316.2Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M307.91,324.67a1.54,1.54,0,1,1-1.49,1.53A1.52,1.52,0,0,1,307.91,324.67Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 25.59,
    height: 3.64,
    x: 312.06,
    y: 76.25,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    transform: "rotate(-71.74 324.852 78.067)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.91,
    height: 17.78,
    x: 312.79,
    y: 77.26,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    transform: "rotate(-71.74 314.758 86.143)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M275.73,296.18a1.11,1.11,0,1,1-1.08,1.11A1.09,1.09,0,0,1,275.73,296.18Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    fillRule: "evenodd",
    d: "M302.07,174l.15,2.67v-.84l.14,2.53h0l.14.42h0l.14,2.95v-.84l.14,1.27v-.28l.14.56.28.14v.28l.42.14.14.28,1.27.14h5.34l.42-.28.28-.14.14-.28.14-.42v-.42l-.14-.43-.14-.28-.28-.14-.14-.14-.7-.14-.29.14-1.4-.14h0l-3.09-.28.14-1.55V179l.42-.14h.14l2.25.14.14.14,1.83-.28-.28.14.56-.28.14-.28.14-.42v-.42l-.14-.42-.14-.29-.28-.14-.14-.14-1.69-.14h0l-1.27-.14h0l-.84-.14h0l-1.12-.14h-.15l-.13-1.26v.56l.13-.56,1.27-.29h.14l1.69-.28h.14L309,174l.28-.14.28-.14.14-.28.15-.42v-.42l-.15-.42-.14-.29-.28-.14-.14-.14-.7-.14-.28.14-1,.14-.84.14-.7.15-.84.14-.57.14-.56.14-.56.14-.28.28-.14.14-.28.28-.14.14-.15.56Zm16.31,5.63.14.84.14.28.42.14.42.14,1.41.14,1.55.14h2.1l.43-.14.28-.14.14-.28.14-.42v-.42l-.14-.42-.14-.29L325,179l-.14-.14-1.69-.14h0l-2.25-.28h-.28l-1.69.14h0l-.14.14h0l-.14.14h0l-.14.14h0v.14l-.14.43Zm.14-3.8.14.7.14.28.42.14.43.15,1.26.14,2.39.14h.84l.42-.14.29-.14.14-.29.14-.42v-.42l-.14-.42-.14-.28-.29-.14-.13-.14-1.13-.28H323l-3.24-.15h0l-.28.15-.42.14h0l-.14.14h0l-.14.14h0l-.14.14h0v.14l-.14.42Zm14.06,1.41.14,6.32v-.42l.14.56H333v.14h.14l.14.28h1l.43-.14.28-.14.14-.28.14-.42v-5.62l.28.14.14.28.28.14.14.42.28.14.14.28.28.14.14.43.15.28.13.28.29.14.14.56.28.14v.28l.28.14v.28l.42.14.14.15h.84l.43-.29.28-.14v-.14l.28-.28v-.28l.14-.84.14-.57.14-.7.14-.7.14-.28.14-.28.14-.28.28-.15v.43l.14.56.15.7.13.56.15.71.14.7.14.7.14.57.14.56.14,1,.14.56.14.57.28.14.14.28.14.14h1l-.43.14.85-.28.28-.14.14-.28.14-.43v-.56l-.14-.42-.14-.7-.14-.56-.14-.57-.14-.56-.14-.7-.14-.71-.14-.7-.15-.56-.14-.7-.14-.57-.14-.56-.14-.28-.14-.28-.14-.84-.14-.42-.14-.43-.14-.28-.28-.28-.28-.28-.42-.14H342l-.42.14-.28.14-.28.28-.28.14-.28.28-.14.28-.14.15-.28.42-.14.14-.29.42-.14.28-.14.28-.14.42-.14.28-.14.28-.14.43-.14-.28-.14-.15-.14-.28-.28-.14-.14-.28-.28-.28-.14-.28-.28-.14-.15-.28-.14-.14-.14-.28-.28-.14-.28-.28-.28-.15-.42-.14-.28-.14-.57-.14-.28.14-.42.14h0l-.14.14h-.14v.15l-.28.28-.14.28-.14.28-.14.42-.14.56-.14,1Zm13.35-1.13.14,1.27h0l.14.7.14.28.14.28.14.42.14.28.15.29.13.28.29.14.14.42.28.14.14.28.28.14.14.28.28.14.28.14.14.29.42.13.29.15.28.14.42.14.7.14.7.14h2.25l.57-.14.56-.14.7-.14.28-.14.28-.15.28-.13.14-.29.14-.28v-.56l-.14-.42-.14-.28-.28-.14-.42-.14h0l-.42-.14-.28.14-.7.14-.57.14h-2.39l-.56-.14-.42-.14-.28-.14-.14-.29-.28-.14-.14-.28-.28-.14-.15-.28-.28-.14L349,178l-.14-.42-.14-.28-.14-.85v-.42l.14-.42.14-.28.28-.28.14-.14.29-.28.14-.15.42-.28.14-.14.56-.28h.84l.29.14.56.14.42.14h.42l.42-.14.28-.14.14-.28.14-.42v-.56l-.14-.42-.14-.28-.28-.15-.28-.28-.56-.14-.56-.14-.57-.14h-1.12l-.56.14-.28.14-.43.14-.28.28-.28.15-.28.14-.28.28-.28.14-.28.28-.14.14-.28.28-.14.14-.28.28-.15.14-.14.28-.14.14-.14.43-.14.42-.14.42-.14.56Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "356.85 168.91 356.91 169.29 356.97 169.42 357.17 169.48 357.29 169.54 357.67 169.54 357.86 169.48 357.99 169.42 357.99 169.35 358.5 169.29 358.24 169.29 358.5 169.35 358.37 169.93 358.31 170.18 358.24 170.24 358.12 170.5 358.05 170.69 357.99 170.81 357.93 170.88 357.8 171.13 357.74 171.19 357.67 171.32 357.61 171.38 357.48 171.57 357.42 171.7 357.36 171.83 357.29 171.89 357.17 172.15 357.1 172.27 357.1 172.59 357.17 172.72 357.23 172.91 357.36 172.97 357.42 173.09 357.74 173.16 358.56 173.16 359.38 173.09 359.64 173.03 360.21 172.97 360.46 172.91 360.59 172.84 360.72 172.78 360.72 172.72 360.84 172.59 360.84 172.46 360.84 172.27 360.78 172.08 360.72 171.95 360.59 171.89 360.4 171.76 360.27 171.76 359.89 171.83 359.89 171.83 359.38 171.89 359.26 171.95 358.69 171.89 358.69 171.89 358.81 171.76 358.88 171.57 359 171.45 359 171.38 359.07 171.26 359.13 171.13 359.19 170.94 359.32 170.81 359.38 170.62 359.45 170.5 359.51 170.24 359.57 169.93 359.64 169.61 359.64 169.16 359.57 168.91 359.51 168.72 359.45 168.59 359.38 168.47 359.26 168.4 359.07 168.28 358.94 168.28 358.75 168.15 358.62 168.15 358.18 168.09 358.18 168.09 358.05 168.15 357.67 168.21 357.55 168.28 357.29 168.34 357.17 168.47 357.1 168.47 356.97 168.66 356.91 168.72 356.85 168.91"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "215.82 149.83 215.93 150.96 216.04 151.41 216.16 152.54 216.27 153.22 216.38 155.14 216.5 156.95 216.61 157.29 216.72 157.52 217.06 157.63 217.4 157.74 217.74 157.74 218.08 157.63 218.31 157.52 218.31 157.4 218.53 157.18 218.53 156.95 218.53 155.25 218.53 153.33 221.25 153.33 221.36 155.03 221.36 155.03 221.47 157.18 221.59 157.52 221.7 157.74 222.04 157.86 222.38 157.97 222.72 157.97 223.06 157.86 223.28 157.74 223.28 157.63 223.51 157.4 223.51 157.18 223.51 156.05 223.39 154.12 223.28 151.18 223.17 149.94 223.06 149.49 222.94 148.81 222.83 148.35 222.72 148.13 222.49 148.02 222.38 147.9 221.36 148.02 221.36 148.02 221.25 148.13 221.25 148.13 221.13 148.24 221.13 148.24 221.02 148.35 221.02 148.35 221.02 148.47 220.91 149.15 220.91 149.15 221.02 149.94 221.13 150.96 221.13 151.18 218.19 151.18 218.19 151.18 218.08 150.17 217.97 150.05 217.85 149.71 217.74 149.49 217.63 149.26 217.4 149.15 217.29 149.03 216.27 149.15 216.27 149.15 216.16 149.26 216.16 149.26 216.04 149.37 216.04 149.37 215.93 149.49 215.93 149.49 215.93 149.6 215.82 149.83"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "175.4 179.16 175.51 180.29 175.63 180.75 175.74 181.88 175.85 182.56 175.97 184.48 176.08 186.29 176.19 186.63 176.3 186.85 176.64 186.97 176.98 187.08 177.32 187.08 177.66 186.97 177.89 186.85 177.89 186.74 178.11 186.51 178.11 186.29 178.11 184.59 178.11 182.67 180.83 182.67 180.94 184.37 180.94 184.37 181.05 186.51 181.17 186.85 181.28 187.08 181.62 187.19 181.96 187.31 182.3 187.31 182.64 187.19 182.86 187.08 182.86 186.97 183.09 186.74 183.09 186.51 183.09 185.38 182.98 183.46 182.86 180.52 182.75 179.28 182.64 178.82 182.52 178.15 182.41 177.69 182.3 177.47 182.07 177.35 181.96 177.24 180.94 177.35 180.94 177.35 180.83 177.47 180.83 177.47 180.72 177.58 180.72 177.58 180.6 177.69 180.6 177.69 180.6 177.81 180.49 178.48 180.49 178.48 180.6 179.28 180.72 180.29 180.72 180.52 177.77 180.52 177.77 180.52 177.66 179.5 177.55 179.39 177.43 179.05 177.32 178.82 177.21 178.6 176.98 178.48 176.87 178.37 175.85 178.48 175.85 178.48 175.74 178.6 175.74 178.6 175.63 178.71 175.63 178.71 175.51 178.82 175.51 178.82 175.51 178.94 175.4 179.16"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "238.53 186.83 238.64 187.85 238.64 187.85 238.75 188.41 238.87 188.64 238.98 188.86 239.09 189.2 239.2 189.43 239.32 189.66 239.43 189.88 239.66 190 239.77 190.33 240 190.45 240.11 190.67 240.34 190.78 240.45 191.01 240.68 191.13 240.9 191.24 241.01 191.47 241.35 191.58 241.58 191.69 241.81 191.8 242.15 191.92 242.71 192.03 243.28 192.14 245.09 192.14 245.54 192.03 245.99 191.92 246.56 191.8 246.78 191.69 247.01 191.58 247.23 191.47 247.35 191.24 247.46 191.01 247.46 190.56 247.35 190.22 247.23 190 247.01 189.88 246.67 189.77 246.67 189.77 246.33 189.66 246.1 189.77 245.54 189.88 245.09 190 243.16 190 242.71 189.88 242.37 189.77 242.15 189.66 242.03 189.43 241.81 189.32 241.69 189.09 241.47 188.98 241.35 188.75 241.13 188.64 241.01 188.41 240.9 188.07 240.79 187.85 240.68 187.17 240.68 186.83 240.79 186.49 240.9 186.26 241.13 186.03 241.24 185.92 241.47 185.7 241.58 185.58 241.92 185.36 242.03 185.24 242.48 185.02 243.16 185.02 243.39 185.13 243.84 185.24 244.18 185.36 244.52 185.36 244.86 185.24 245.09 185.13 245.2 184.9 245.31 184.57 245.31 184.11 245.2 183.77 245.09 183.55 244.86 183.43 244.63 183.21 244.18 183.09 243.73 182.98 243.28 182.87 242.37 182.87 241.92 182.98 241.69 183.09 241.35 183.21 241.13 183.43 240.9 183.55 240.68 183.66 240.45 183.89 240.22 184 240 184.23 239.88 184.34 239.66 184.57 239.54 184.68 239.32 184.9 239.2 185.02 239.09 185.24 238.98 185.36 238.87 185.7 238.75 186.03 238.64 186.38 238.53 186.83 238.53 186.83"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "216.01 173.02 216.13 174.04 216.13 174.04 216.24 174.6 216.35 174.83 216.47 175.06 216.58 175.39 216.69 175.62 216.81 175.85 216.92 176.07 217.15 176.19 217.26 176.53 217.49 176.64 217.6 176.87 217.82 176.98 217.94 177.21 218.16 177.32 218.39 177.43 218.5 177.66 218.84 177.77 219.07 177.88 219.29 178 219.63 178.11 220.2 178.22 220.76 178.34 222.57 178.34 223.03 178.22 223.48 178.11 224.04 178 224.27 177.88 224.5 177.77 224.72 177.66 224.84 177.43 224.95 177.21 224.95 176.75 224.84 176.41 224.72 176.19 224.5 176.07 224.16 175.96 224.16 175.96 223.82 175.85 223.59 175.96 223.03 176.07 222.57 176.19 220.65 176.19 220.2 176.07 219.86 175.96 219.63 175.85 219.52 175.62 219.29 175.51 219.18 175.28 218.96 175.17 218.84 174.94 218.62 174.83 218.5 174.6 218.39 174.26 218.28 174.04 218.16 173.36 218.16 173.02 218.28 172.68 218.39 172.45 218.62 172.23 218.73 172.11 218.96 171.89 219.07 171.77 219.41 171.55 219.52 171.44 219.97 171.21 220.65 171.21 220.88 171.32 221.33 171.44 221.67 171.55 222.01 171.55 222.35 171.44 222.57 171.32 222.69 171.1 222.8 170.76 222.8 170.31 222.69 169.97 222.57 169.74 222.35 169.63 222.12 169.4 221.67 169.29 221.22 169.17 220.76 169.06 219.86 169.06 219.41 169.17 219.18 169.29 218.84 169.4 218.62 169.63 218.39 169.74 218.16 169.85 217.94 170.08 217.71 170.19 217.49 170.42 217.37 170.53 217.15 170.76 217.03 170.87 216.81 171.1 216.69 171.21 216.58 171.44 216.47 171.55 216.35 171.89 216.24 172.23 216.13 172.57 216.01 173.02 216.01 173.02"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "196.15 209.72 196.27 210.74 196.27 210.74 196.38 211.3 196.49 211.53 196.6 211.75 196.72 212.09 196.83 212.32 196.95 212.54 197.06 212.77 197.28 212.88 197.4 213.22 197.62 213.34 197.74 213.56 197.96 213.68 198.08 213.9 198.3 214.01 198.53 214.13 198.64 214.35 198.98 214.47 199.21 214.58 199.43 214.69 199.77 214.81 200.34 214.92 200.9 215.03 202.71 215.03 203.17 214.92 203.62 214.81 204.18 214.69 204.41 214.58 204.63 214.47 204.86 214.35 204.98 214.13 205.09 213.9 205.09 213.45 204.98 213.11 204.86 212.88 204.63 212.77 204.3 212.66 204.3 212.66 203.96 212.54 203.73 212.66 203.17 212.77 202.71 212.88 200.79 212.88 200.34 212.77 200 212.66 199.77 212.54 199.66 212.32 199.43 212.21 199.32 211.98 199.09 211.87 198.98 211.64 198.75 211.53 198.64 211.3 198.53 210.96 198.41 210.74 198.3 210.06 198.3 209.72 198.41 209.38 198.53 209.15 198.75 208.92 198.87 208.81 199.09 208.59 199.21 208.47 199.55 208.25 199.66 208.13 200.11 207.91 200.79 207.91 201.02 208.02 201.47 208.13 201.81 208.25 202.15 208.25 202.49 208.13 202.71 208.02 202.83 207.79 202.94 207.46 202.94 207 202.83 206.66 202.71 206.44 202.49 206.32 202.26 206.1 201.81 205.99 201.36 205.87 200.9 205.76 200 205.76 199.55 205.87 199.32 205.99 198.98 206.1 198.75 206.32 198.53 206.44 198.3 206.55 198.08 206.78 197.85 206.89 197.62 207.12 197.51 207.23 197.28 207.46 197.17 207.57 196.95 207.79 196.83 207.91 196.72 208.13 196.6 208.25 196.49 208.59 196.38 208.92 196.27 209.26 196.15 209.72 196.15 209.72"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "196.15 187.96 196.27 188.98 196.27 188.98 196.38 189.54 196.49 189.77 196.6 190 196.72 190.34 196.83 190.56 196.95 190.79 197.06 191.02 197.28 191.13 197.4 191.47 197.62 191.58 197.74 191.81 197.96 191.92 198.08 192.15 198.3 192.26 198.53 192.38 198.64 192.6 198.98 192.71 199.21 192.83 199.43 192.94 199.77 193.05 200.34 193.16 200.9 193.28 202.71 193.28 203.17 193.16 203.62 193.05 204.18 192.94 204.41 192.83 204.63 192.71 204.86 192.6 204.98 192.38 205.09 192.15 205.09 191.69 204.98 191.36 204.86 191.13 204.63 191.02 204.3 190.9 204.3 190.9 203.96 190.79 203.73 190.9 203.17 191.02 202.71 191.13 200.79 191.13 200.34 191.02 200 190.9 199.77 190.79 199.66 190.56 199.43 190.45 199.32 190.23 199.09 190.11 198.98 189.89 198.75 189.77 198.64 189.54 198.53 189.21 198.41 188.98 198.3 188.3 198.3 187.96 198.41 187.62 198.53 187.4 198.75 187.17 198.87 187.06 199.09 186.83 199.21 186.72 199.55 186.49 199.66 186.38 200.11 186.15 200.79 186.15 201.02 186.27 201.47 186.38 201.81 186.49 202.15 186.49 202.49 186.38 202.71 186.27 202.83 186.04 202.94 185.7 202.94 185.25 202.83 184.91 202.71 184.68 202.49 184.57 202.26 184.34 201.81 184.23 201.36 184.12 200.9 184 200 184 199.55 184.12 199.32 184.23 198.98 184.34 198.75 184.57 198.53 184.68 198.3 184.8 198.08 185.02 197.85 185.13 197.62 185.36 197.51 185.47 197.28 185.7 197.17 185.81 196.95 186.04 196.83 186.15 196.72 186.38 196.6 186.49 196.49 186.83 196.38 187.17 196.27 187.51 196.15 187.96 196.15 187.96"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "238.53 209.72 238.64 210.74 238.64 210.74 238.75 211.3 238.87 211.53 238.98 211.75 239.09 212.09 239.2 212.32 239.32 212.54 239.43 212.77 239.66 212.88 239.77 213.22 240 213.34 240.11 213.56 240.34 213.68 240.45 213.9 240.68 214.01 240.9 214.13 241.01 214.35 241.35 214.47 241.58 214.58 241.81 214.69 242.15 214.81 242.71 214.92 243.28 215.03 245.09 215.03 245.54 214.92 245.99 214.81 246.56 214.69 246.78 214.58 247.01 214.47 247.23 214.35 247.35 214.13 247.46 213.9 247.46 213.45 247.35 213.11 247.23 212.88 247.01 212.77 246.67 212.66 246.67 212.66 246.33 212.54 246.1 212.66 245.54 212.77 245.09 212.88 243.16 212.88 242.71 212.77 242.37 212.66 242.15 212.54 242.03 212.32 241.81 212.21 241.69 211.98 241.47 211.87 241.35 211.64 241.13 211.53 241.01 211.3 240.9 210.96 240.79 210.74 240.68 210.06 240.68 209.72 240.79 209.38 240.9 209.15 241.13 208.92 241.24 208.81 241.47 208.59 241.58 208.47 241.92 208.25 242.03 208.13 242.48 207.91 243.16 207.91 243.39 208.02 243.84 208.13 244.18 208.25 244.52 208.25 244.86 208.13 245.09 208.02 245.2 207.79 245.31 207.46 245.31 207 245.2 206.66 245.09 206.44 244.86 206.32 244.63 206.1 244.18 205.99 243.73 205.87 243.28 205.76 242.37 205.76 241.92 205.87 241.69 205.99 241.35 206.1 241.13 206.32 240.9 206.44 240.68 206.55 240.45 206.78 240.22 206.89 240 207.12 239.88 207.23 239.66 207.46 239.54 207.57 239.32 207.79 239.2 207.91 239.09 208.13 238.98 208.25 238.87 208.59 238.75 208.92 238.64 209.26 238.53 209.72 238.53 209.72"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "216.39 225.37 216.51 226.39 216.51 226.39 216.62 226.95 216.73 227.18 216.85 227.41 216.96 227.75 217.07 227.97 217.19 228.2 217.3 228.42 217.52 228.54 217.64 228.88 217.87 228.99 217.98 229.22 218.2 229.33 218.32 229.56 218.54 229.67 218.77 229.78 218.88 230.01 219.22 230.12 219.45 230.24 219.67 230.35 220.01 230.46 220.58 230.57 221.14 230.69 222.95 230.69 223.41 230.57 223.86 230.46 224.42 230.35 224.65 230.24 224.88 230.12 225.1 230.01 225.22 229.78 225.33 229.56 225.33 229.1 225.22 228.76 225.1 228.54 224.88 228.42 224.54 228.31 224.54 228.31 224.2 228.2 223.97 228.31 223.41 228.42 222.95 228.54 221.03 228.54 220.58 228.42 220.24 228.31 220.01 228.2 219.9 227.97 219.67 227.86 219.56 227.63 219.34 227.52 219.22 227.29 219 227.18 218.88 226.95 218.77 226.62 218.66 226.39 218.54 225.71 218.54 225.37 218.66 225.03 218.77 224.8 219 224.58 219.11 224.47 219.34 224.24 219.45 224.13 219.79 223.9 219.9 223.79 220.35 223.56 221.03 223.56 221.26 223.67 221.71 223.79 222.05 223.9 222.39 223.9 222.73 223.79 222.95 223.67 223.07 223.45 223.18 223.11 223.18 222.66 223.07 222.32 222.95 222.09 222.73 221.98 222.5 221.75 222.05 221.64 221.6 221.52 221.14 221.41 220.24 221.41 219.79 221.52 219.56 221.64 219.22 221.75 219 221.98 218.77 222.09 218.54 222.2 218.32 222.43 218.09 222.54 217.87 222.77 217.75 222.88 217.52 223.11 217.41 223.22 217.19 223.45 217.07 223.56 216.96 223.79 216.85 223.9 216.73 224.24 216.62 224.58 216.51 224.92 216.39 225.37 216.39 225.37"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 204.45,
    x2: 213.15,
    y1: 182.97,
    y2: 176.77,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 229.42,
    x2: 237.74,
    y1: 176.25,
    y2: 182.07,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 241.95,
    x2: 241.95,
    y1: 194.41,
    y2: 203.82,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 199.06,
    x2: 199.06,
    y1: 194.69,
    y2: 204.48,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 204.59,
    x2: 212.54,
    y1: 218.28,
    y2: 224.62,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 238.53,
    x2: 227.44,
    y1: 216.16,
    y2: 222.6,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 205.79,
    x2: 214.49,
    y1: 185.3,
    y2: 179.1,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 206.34,
    x2: 214.29,
    y1: 216.11,
    y2: 222.45,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 243.76,
    x2: 243.76,
    y1: 194.41,
    y2: 203.82,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 219.99,
    x2: 219.99,
    y1: 159.84,
    y2: 167.28,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 185.24,
    x2: 194.59,
    y1: 183.37,
    y2: 186.59,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 188.91,
    x2: 195.2,
    y1: 218.07,
    y2: 213.6,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "178.71 215.73 178.82 216.87 178.94 217.32 179.05 218.45 179.16 219.13 179.28 221.05 179.39 222.86 179.5 223.2 179.61 223.43 179.95 223.54 180.29 223.65 180.63 223.65 180.97 223.54 181.2 223.43 181.2 223.31 181.42 223.09 181.42 222.86 181.42 221.16 181.42 219.24 184.14 219.24 184.25 220.94 184.25 220.94 184.36 223.09 184.48 223.43 184.59 223.65 184.93 223.76 185.27 223.88 185.61 223.88 185.95 223.76 186.18 223.65 186.18 223.54 186.4 223.31 186.4 223.09 186.4 221.96 186.29 220.03 186.18 217.09 186.06 215.85 185.95 215.4 185.84 214.72 185.72 214.26 185.61 214.04 185.38 213.93 185.27 213.81 184.25 213.93 184.25 213.93 184.14 214.04 184.14 214.04 184.03 214.15 184.03 214.15 183.91 214.26 183.91 214.26 183.91 214.38 183.8 215.06 183.8 215.06 183.91 215.85 184.03 216.87 184.03 217.09 181.08 217.09 181.08 217.09 180.97 216.07 180.86 215.96 180.74 215.62 180.63 215.4 180.52 215.17 180.29 215.06 180.18 214.94 179.16 215.06 179.16 215.06 179.05 215.17 179.05 215.17 178.94 215.28 178.94 215.28 178.82 215.4 178.82 215.4 178.82 215.51 178.71 215.73"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "257.64 216.04 257.75 217.17 257.87 217.62 257.98 218.75 258.09 219.43 258.21 221.35 258.32 223.16 258.43 223.5 258.54 223.73 258.88 223.84 259.22 223.96 259.56 223.96 259.9 223.84 260.13 223.73 260.13 223.62 260.36 223.39 260.36 223.16 260.36 221.47 260.36 219.54 263.07 219.54 263.18 221.24 263.18 221.24 263.3 223.39 263.41 223.73 263.52 223.96 263.86 224.07 264.2 224.18 264.54 224.18 264.88 224.07 265.11 223.96 265.11 223.84 265.33 223.62 265.33 223.39 265.33 222.26 265.22 220.34 265.11 217.39 264.99 216.15 264.88 215.7 264.76 215.02 264.65 214.57 264.54 214.34 264.31 214.23 264.2 214.11 263.18 214.23 263.18 214.23 263.07 214.34 263.07 214.34 262.96 214.46 262.96 214.46 262.84 214.57 262.84 214.57 262.84 214.68 262.73 215.36 262.73 215.36 262.84 216.15 262.96 217.17 262.96 217.39 260.01 217.39 260.01 217.39 259.9 216.38 259.79 216.26 259.67 215.93 259.56 215.7 259.45 215.47 259.22 215.36 259.11 215.25 258.09 215.36 258.09 215.36 257.98 215.47 257.98 215.47 257.87 215.59 257.87 215.59 257.75 215.7 257.75 215.7 257.75 215.81 257.64 216.04"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 255.34,
    x2: 248.24,
    y1: 218.69,
    y2: 215.33,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 220.5,
    x2: 220.5,
    y1: 233.5,
    y2: 240.94,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "217.71 246.3 217.82 247.43 217.93 247.88 218.05 249.02 218.16 249.69 218.27 251.62 218.39 253.43 218.5 253.77 218.61 253.99 218.95 254.1 219.29 254.22 219.63 254.22 219.97 254.1 220.2 253.99 220.2 253.88 220.42 253.65 220.42 253.43 220.42 251.73 220.42 249.81 223.14 249.81 223.25 251.5 223.25 251.5 223.36 253.65 223.48 253.99 223.59 254.22 223.93 254.33 224.27 254.45 224.61 254.45 224.95 254.33 225.17 254.22 225.17 254.1 225.4 253.88 225.4 253.65 225.4 252.52 225.29 250.6 225.17 247.66 225.06 246.41 224.95 245.96 224.83 245.28 224.72 244.83 224.61 244.6 224.38 244.49 224.27 244.38 223.25 244.49 223.25 244.49 223.14 244.6 223.14 244.6 223.02 244.72 223.02 244.72 222.91 244.83 222.91 244.83 222.91 244.94 222.8 245.62 222.8 245.62 222.91 246.41 223.02 247.43 223.02 247.66 220.08 247.66 220.08 247.66 219.97 246.64 219.86 246.53 219.74 246.19 219.63 245.96 219.52 245.74 219.29 245.62 219.18 245.51 218.16 245.62 218.16 245.62 218.05 245.74 218.05 245.74 217.93 245.85 217.93 245.85 217.82 245.96 217.82 245.96 217.82 246.07 217.71 246.3"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 246.73,
    x2: 252.59,
    y1: 181.42,
    y2: 177.25,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "254.53 173.96 254.65 175.09 254.76 175.54 254.87 176.68 254.99 177.35 255.1 179.28 255.21 181.09 255.33 181.43 255.44 181.65 255.78 181.76 256.12 181.88 256.46 181.88 256.79 181.76 257.02 181.65 257.02 181.54 257.25 181.31 257.25 181.09 257.25 179.39 257.25 177.47 259.96 177.47 260.08 179.16 260.08 179.16 260.19 181.31 260.3 181.65 260.42 181.88 260.75 181.99 261.09 182.1 261.43 182.1 261.77 181.99 262 181.88 262 181.76 262.23 181.54 262.23 181.31 262.23 180.18 262.11 178.26 262 175.32 261.88 174.07 261.77 173.62 261.66 172.94 261.55 172.49 261.43 172.26 261.21 172.15 261.09 172.04 260.08 172.15 260.08 172.15 259.96 172.26 259.96 172.26 259.85 172.38 259.85 172.38 259.74 172.49 259.74 172.49 259.74 172.6 259.62 173.28 259.62 173.28 259.74 174.07 259.85 175.09 259.85 175.32 256.91 175.32 256.91 175.32 256.79 174.3 256.68 174.19 256.57 173.85 256.46 173.62 256.34 173.4 256.12 173.28 256 173.17 254.99 173.28 254.99 173.28 254.87 173.4 254.87 173.4 254.76 173.51 254.76 173.51 254.65 173.62 254.65 173.62 254.65 173.74 254.53 173.96"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 290.55,
    x2: 363.03,
    y1: 197.18,
    y2: 197.18,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 305.92,
    x2: 362.34,
    y1: 208.09,
    y2: 208.09,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M369.37,323.54H333v-12.7h37.06m8.45,0h13.66v12.7h-2.08"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M442.68,302.34c4.38-2.55,14.87-6.52,18.56-5.9,6,1-2.35,7.18-7.85,13.91-3.26,4-1.38,3.68.66,3.91,4.34.49,3.64,4.67-.75,6.2-4.58,1.59-12.43,2.22-16.63,8.24-3,4.28.27,5.39,3.62,4.45,7.27-2,7,1.74.73,4.81-6.44,3.16-16.18,5.73-18.22,12.15-1.26,4,.64,3.89,2.84,3.41,8.54-1.89,4,4.87.27,7.49-12.83,9-17.53,17.75-20.63,38.33h-3.9c-.06-11.33-.19-35.91-.19-45.76,0-13,5.1-10.71,5.71-8.87s3.47,1.48,4.79-6.68c.14-.83,1.89-21.88,6-18,.75.71.17,2.59,2.34,2.81,1.51.15,3.09-.71,4.14-3.63,1.93-5.4,8.82-21.15,13.56-20.29,2.45.45.75,2.87.42,4.6C438.11,303.53,437.4,305.41,442.68,302.34Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M450,304.25c-29.24,16.67-45,68.65-47,95.09"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M401.05,355.69a22.12,22.12,0,0,0-1.06,5.58c.1,1.09.6,1.2,1.21,1.1m-12.83,1.29c.73.14,1.43.24,1.78-.19,1.43-1.74-5.5-10.25-9.48-12.8s-.35-5.3,2.7-4.38c7,2.11-9.63-13.71-9.76-13.84-1.77-1.82-1.67-3.82,1.4-4.26,3.95-.55-1.82-3.22-4.65-6.38a7.85,7.85,0,0,1-.75-1c-1.63-2.48,1.63-2.57,3.82-2,3.78,1,2.53-1.87,1-4.32s-4.16-5.52-3.87-7.49c.16-1.11,4.27-1.6,7.32.56,3.37,2.39,3.38,6.72,5.41,9.13a1.48,1.48,0,0,0,1.9.5c2.14-.81-1.33-4.89,1.22-4.48s4.9,7,4.9,11.93,3.36,4.28,4.79,2.44,3.46.42,1.93,6.32-2.34,14.58,0,13.05,3.67-3.81,5-2.19"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M378.1,314.45c13.42,20.28,23.35,59.14,23.48,84.89"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M401.14,399.34c-1.44-11.17-4.51-32.41-7.84-33.36-2-.56.11,3.87-2.36,3.81-2-.06-3.75-14.12-6.25-14.47s-2.91.3-4-1-4.61-12.34-7.34-12.39-1.53,3.62-4,2.4-8.62-6.84-13.41-6.22,3.37,6.32,5,9-2.09,1.17-1.58,3.82,14,6,13.61,8.51-6.68.36-5.76,3.42c.68,2.27,24,9.49,15.36,12.14-5.19,1.58-4.47,3.06-2.17,4.44,10.88,6.58,14.74,13.87,16.9,19.95Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M362.12,342.19c18.27,12.48,30.27,35.95,38.52,57.15"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 273.01,
    x2: 331.78,
    y1: 226.67,
    y2: 226.67,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 281.43,
    x2: 341.57,
    y1: 235.05,
    y2: 235.05,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 272.42,
    x2: 307.1,
    y1: 243.47,
    y2: 243.47,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 313.36,
    x2: 332.95,
    y1: 243.86,
    y2: 243.86,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 63.37,
    height: 63.37,
    x: 404.76,
    y: 187.45,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 55.64,
    height: 3.68,
    x: 408.63,
    y: 216.68,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 36.97,
    height: 23.09,
    x: 408.44,
    y: 191.25,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 15.23,
    height: 10.51,
    x: 449.22,
    y: 191.25,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 15.23,
    height: 10.51,
    x: 449.22,
    y: 203.84,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M408.44,224.05h10.81m6.75,0h38.45"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M408.44,227.61h31.69m9.09,0h15.23"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 408.44,
    x2: 464.45,
    y1: 231.17,
    y2: 231.17,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M408.44,234.73h12.41m11.54,0h32.06"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 408.44,
    x2: 464.45,
    y1: 238.3,
    y2: 238.3,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 408.44,
    x2: 464.45,
    y1: 241.86,
    y2: 241.86,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M408.44,245.42h21.37m10.19,0h24.45"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M259.18,98.73a9.79,9.79,0,1,1-9.79,9.79A9.8,9.8,0,0,1,259.18,98.73Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M286,114.51a4,4,0,1,1-4.05,4A4,4,0,0,1,286,114.51Z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 30.17,
    height: 11.36,
    x: 405.16,
    y: 256.17,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M447.14,345.59a3.82,3.82,0,1,1-3.82,3.82A3.82,3.82,0,0,1,447.14,345.59Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 445.59,
    cy: 327.96,
    r: 2.12,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.57,
    cy: 278.58,
    r: 4.31,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M52.93,215.91a9.39,9.39,0,1,1-6.65,2.75,9.39,9.39,0,0,1,6.65-2.75Zm0,1.57a7.84,7.84,0,1,1-7.84,7.83A7.82,7.82,0,0,1,52.93,217.48Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M35.49,227.76a3.62,3.62,0,1,1-2.56,1.06,3.66,3.66,0,0,1,2.56-1.06Zm0,1.57a2.06,2.06,0,1,1-2.05,2.06A2.06,2.06,0,0,1,35.49,229.33Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M52.59,239a4.56,4.56,0,1,1-3.22,7.77A4.55,4.55,0,0,1,52.59,239Zm0,1.56a3,3,0,1,1-3,3A3,3,0,0,1,52.59,240.59Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M404.16,399.34c3-8.39,8.41-22.91,11-23.09,1.58-.11-.7,2.91,1.18,3.26,1.52.28,5.1-10.07,7-9.94s2.15.7,3.21-.12,5.47-8.58,7.54-8.18.58,3,2.62,2.45,7.61-3.78,11.14-2.55-3.56,4.24-5.22,6,1.39,1.22.58,3.14-11.56,2.26-11.66,4.25,5,1.34,3.81,3.51c-.88,1.6-19.69,3.31-13.57,6.7,3.67,2,2.89,3,.93,3.71-8.22,2.85-12.37,7-15,10.88h-3.56Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M441.07,365c-15.46,6.35-26.89,20.23-36.22,34.36"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M375.69,399.34h50.58c8.46,0,9.81,2,8.58,6.79-3.35,13-8,27.79-11.84,41H380.66c-3.05-11.28-10.45-32.24-12.21-42.59C367.85,401.07,369.29,399.34,375.69,399.34Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M433,413.13c-1.84,6.68-3.91,13.67-6,20.54-5.17-2.17-11.57-3.64-17.53-1.62-10.1,3.43-22.93,7.85-31.27,6.82-2.13-6.94-4.78-15.12-6.83-22.3,3.8,2.47,10.14,4.67,20.44,3.31C407.52,417.8,415.23,406.48,433,413.13Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M364.6,379a4.9,4.9,0,1,1-4.8,4.9A4.85,4.85,0,0,1,364.6,379Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeDasharray: "2 3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M113.51,152.11s9.24-9.13,15.78.73,11.53,9.54,18.76,3.32c15-12.92,21.63,2.7,21.85,10.35"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M94.1,251.13a69.52,69.52,0,0,0,3.58,7.37c5.73,9.72,17.37-4.57,24.5-14.05m0,0c2-2.73,3.73-5.06,4.78-6.3,7.83,5.7,12.09,12.61,13.72,25.21-11,3.69-32.53,26.07-45.57,25.68-19-.58-25.11-44.79-24-57.3.55-6.17,3.2-7.77,6.89-8.22a31.76,31.76,0,0,1,4.09-.1"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "375.35 238.8 375.45 239.8 375.55 240.2 375.65 241.19 375.75 241.79 375.85 243.49 375.94 245.08 376.05 245.38 376.14 245.58 376.44 245.68 376.74 245.78 377.04 245.78 377.34 245.68 377.54 245.58 377.54 245.48 377.74 245.28 377.74 245.08 377.74 243.59 377.74 241.89 380.13 241.89 380.24 243.39 380.24 243.39 380.33 245.28 380.43 245.58 380.53 245.78 380.83 245.88 381.13 245.98 381.43 245.98 381.73 245.88 381.93 245.78 381.93 245.68 382.13 245.48 382.13 245.28 382.13 244.29 382.03 242.59 381.93 240 381.83 238.9 381.73 238.5 381.63 237.9 381.53 237.5 381.43 237.3 381.23 237.21 381.13 237.1 380.24 237.21 380.24 237.21 380.13 237.3 380.13 237.3 380.04 237.4 380.04 237.4 379.93 237.5 379.93 237.5 379.93 237.6 379.83 238.2 379.83 238.2 379.93 238.9 380.04 239.8 380.04 240 377.44 240 377.44 240 377.34 239.1 377.24 239 377.14 238.7 377.04 238.5 376.94 238.3 376.74 238.2 376.64 238.1 375.75 238.2 375.75 238.2 375.65 238.3 375.65 238.3 375.55 238.4 375.55 238.4 375.45 238.5 375.45 238.5 375.45 238.6 375.35 238.8"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "342.05 264.99 342.15 265.94 342.24 266.31 342.34 267.26 342.43 267.82 342.53 269.43 342.62 270.94 342.71 271.22 342.81 271.41 343.09 271.5 343.37 271.6 343.66 271.6 343.94 271.5 344.13 271.41 344.13 271.32 344.32 271.13 344.32 270.94 344.32 269.52 344.32 267.92 346.58 267.92 346.68 269.33 346.68 269.33 346.77 271.13 346.87 271.41 346.96 271.6 347.25 271.69 347.53 271.79 347.81 271.79 348.09 271.69 348.28 271.6 348.28 271.5 348.47 271.32 348.47 271.13 348.47 270.18 348.38 268.58 348.28 266.13 348.19 265.09 348.09 264.71 348 264.14 347.91 263.77 347.81 263.58 347.62 263.48 347.53 263.39 346.68 263.48 346.68 263.48 346.58 263.58 346.58 263.58 346.49 263.67 346.49 263.67 346.39 263.77 346.39 263.77 346.39 263.86 346.3 264.43 346.3 264.43 346.39 265.09 346.49 265.94 346.49 266.13 344.04 266.13 344.04 266.13 343.94 265.28 343.85 265.18 343.75 264.9 343.66 264.71 343.56 264.52 343.37 264.43 343.28 264.33 342.43 264.43 342.43 264.43 342.34 264.52 342.34 264.52 342.24 264.62 342.24 264.62 342.15 264.71 342.15 264.71 342.15 264.8 342.05 264.99"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "375.52 259.25 375.62 260.15 375.62 260.15 375.72 260.65 375.82 260.85 375.92 261.05 376.02 261.35 376.12 261.55 376.22 261.75 376.32 261.95 376.52 262.05 376.62 262.35 376.82 262.45 376.92 262.65 377.12 262.75 377.22 262.95 377.42 263.05 377.62 263.15 377.72 263.35 378.02 263.44 378.21 263.54 378.41 263.64 378.71 263.74 379.21 263.84 379.71 263.94 381.31 263.94 381.71 263.84 382.11 263.74 382.6 263.64 382.8 263.54 383 263.44 383.2 263.35 383.3 263.15 383.4 262.95 383.4 262.55 383.3 262.25 383.2 262.05 383 261.95 382.7 261.85 382.7 261.85 382.4 261.75 382.2 261.85 381.71 261.95 381.31 262.05 379.61 262.05 379.21 261.95 378.91 261.85 378.71 261.75 378.61 261.55 378.41 261.45 378.32 261.25 378.12 261.15 378.02 260.95 377.82 260.85 377.72 260.65 377.62 260.35 377.52 260.15 377.42 259.55 377.42 259.25 377.52 258.96 377.62 258.75 377.82 258.56 377.92 258.46 378.12 258.26 378.21 258.16 378.51 257.96 378.61 257.86 379.01 257.66 379.61 257.66 379.81 257.76 380.21 257.86 380.51 257.96 380.81 257.96 381.11 257.86 381.31 257.76 381.41 257.56 381.51 257.26 381.51 256.86 381.41 256.56 381.31 256.36 381.11 256.26 380.91 256.06 380.51 255.96 380.11 255.86 379.71 255.76 378.91 255.76 378.51 255.86 378.32 255.96 378.02 256.06 377.82 256.26 377.62 256.36 377.42 256.46 377.22 256.66 377.02 256.76 376.82 256.96 376.72 257.06 376.52 257.26 376.42 257.36 376.22 257.56 376.12 257.66 376.02 257.86 375.92 257.96 375.82 258.26 375.72 258.56 375.62 258.86 375.52 259.25 375.52 259.25"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "358 291.62 358.11 292.52 358.11 292.52 358.2 293.02 358.3 293.22 358.4 293.42 358.5 293.71 358.6 293.91 358.7 294.11 358.8 294.31 359 294.41 359.1 294.71 359.3 294.81 359.4 295.01 359.6 295.11 359.7 295.31 359.9 295.41 360.1 295.51 360.2 295.71 360.5 295.81 360.7 295.91 360.9 296.01 361.2 296.11 361.69 296.21 362.19 296.31 363.79 296.31 364.19 296.21 364.59 296.11 365.09 296.01 365.29 295.91 365.49 295.81 365.68 295.71 365.79 295.51 365.88 295.31 365.88 294.91 365.79 294.61 365.68 294.41 365.49 294.31 365.19 294.21 365.19 294.21 364.89 294.11 364.69 294.21 364.19 294.31 363.79 294.41 362.09 294.41 361.69 294.31 361.4 294.21 361.2 294.11 361.1 293.91 360.9 293.82 360.8 293.62 360.6 293.52 360.5 293.32 360.3 293.22 360.2 293.02 360.1 292.72 360 292.52 359.9 291.92 359.9 291.62 360 291.32 360.1 291.12 360.3 290.92 360.4 290.82 360.6 290.62 360.7 290.52 361 290.32 361.1 290.22 361.5 290.02 362.09 290.02 362.29 290.12 362.69 290.22 362.99 290.32 363.29 290.32 363.59 290.22 363.79 290.12 363.89 289.92 363.99 289.63 363.99 289.23 363.89 288.93 363.79 288.73 363.59 288.63 363.39 288.43 362.99 288.33 362.59 288.23 362.19 288.13 361.4 288.13 361 288.23 360.8 288.33 360.5 288.43 360.3 288.63 360.1 288.73 359.9 288.83 359.7 289.03 359.5 289.13 359.3 289.33 359.2 289.43 359 289.63 358.9 289.73 358.7 289.92 358.6 290.02 358.5 290.22 358.4 290.32 358.3 290.62 358.2 290.92 358.11 291.22 358 291.62 358 291.62"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "358 272.44 358.11 273.33 358.11 273.33 358.2 273.83 358.3 274.03 358.4 274.23 358.5 274.53 358.6 274.73 358.7 274.93 358.8 275.13 359 275.23 359.1 275.53 359.3 275.63 359.4 275.83 359.6 275.93 359.7 276.13 359.9 276.23 360.1 276.33 360.2 276.52 360.5 276.62 360.7 276.73 360.9 276.82 361.2 276.92 361.69 277.02 362.19 277.12 363.79 277.12 364.19 277.02 364.59 276.92 365.09 276.82 365.29 276.73 365.49 276.62 365.68 276.52 365.79 276.33 365.88 276.13 365.88 275.73 365.79 275.43 365.68 275.23 365.49 275.13 365.19 275.03 365.19 275.03 364.89 274.93 364.69 275.03 364.19 275.13 363.79 275.23 362.09 275.23 361.69 275.13 361.4 275.03 361.2 274.93 361.1 274.73 360.9 274.63 360.8 274.43 360.6 274.33 360.5 274.13 360.3 274.03 360.2 273.83 360.1 273.53 360 273.33 359.9 272.73 359.9 272.44 360 272.14 360.1 271.94 360.3 271.74 360.4 271.64 360.6 271.44 360.7 271.34 361 271.14 361.1 271.04 361.5 270.84 362.09 270.84 362.29 270.94 362.69 271.04 362.99 271.14 363.29 271.14 363.59 271.04 363.79 270.94 363.89 270.74 363.99 270.44 363.99 270.04 363.89 269.74 363.79 269.54 363.59 269.44 363.39 269.24 362.99 269.14 362.59 269.04 362.19 268.94 361.4 268.94 361 269.04 360.8 269.14 360.5 269.24 360.3 269.44 360.1 269.54 359.9 269.64 359.7 269.84 359.5 269.94 359.3 270.14 359.2 270.24 359 270.44 358.9 270.54 358.7 270.74 358.6 270.84 358.5 271.04 358.4 271.14 358.3 271.44 358.2 271.74 358.11 272.04 358 272.44 358 272.44"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 366.3,
    x2: 373.56,
    y1: 268.17,
    y2: 263,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 361.8,
    x2: 361.8,
    y1: 277.95,
    y2: 286.12,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 367.41,
    x2: 374.68,
    y1: 270.11,
    y2: 264.94,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 379.26,
    x2: 379.26,
    y1: 248.87,
    y2: 255.08,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 350.27,
    x2: 358.07,
    y1: 268.5,
    y2: 271.19,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 353.33,
    x2: 358.57,
    y1: 297.46,
    y2: 293.73,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#231f20",
    fillRule: "evenodd",
    points: "342.62 296.93 342.72 297.93 342.82 298.32 342.92 299.32 343.02 299.92 343.12 301.62 343.22 303.21 343.32 303.51 343.42 303.71 343.72 303.81 344.02 303.91 344.32 303.91 344.61 303.81 344.81 303.71 344.81 303.61 345.01 303.41 345.01 303.21 345.01 301.72 345.01 300.02 347.41 300.02 347.51 301.52 347.51 301.52 347.61 303.41 347.71 303.71 347.81 303.91 348.11 304.01 348.4 304.11 348.7 304.11 349 304.01 349.2 303.91 349.2 303.81 349.4 303.61 349.4 303.41 349.4 302.42 349.3 300.72 349.2 298.13 349.1 297.03 349 296.63 348.9 296.03 348.81 295.63 348.7 295.43 348.5 295.33 348.4 295.23 347.51 295.33 347.51 295.33 347.41 295.43 347.41 295.43 347.31 295.53 347.31 295.53 347.21 295.63 347.21 295.63 347.21 295.73 347.11 296.33 347.11 296.33 347.21 297.03 347.31 297.93 347.31 298.13 344.71 298.13 344.71 298.13 344.61 297.23 344.51 297.13 344.41 296.83 344.32 296.63 344.21 296.43 344.02 296.33 343.92 296.23 343.02 296.33 343.02 296.33 342.92 296.43 342.92 296.43 342.82 296.53 342.82 296.53 342.72 296.63 342.72 296.63 342.72 296.73 342.62 296.93"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M341.08,314.18a3,3,0,1,1-3,3A3,3,0,0,1,341.08,314.18Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M350.59,314.18a3,3,0,1,1-3,3A3,3,0,0,1,350.59,314.18Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M360.11,314.18a3,3,0,1,1-3,3A3,3,0,0,1,360.11,314.18Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    fillRule: "evenodd",
    d: "M261.82,153.57l.11,1,.12.12.11.46.12.23.12.23.23.12.11.23.23.12.12.23.35.12.23.11.11.23.47.12.23.11.46.12.7.12h1l.69-.12.35-.12.35-.11.23-.12.23-.11.11-.12.35-.23v-.12l.23-.23v-.11l.24-.24v-.23l.11-.46V154l-.11-.34-.12-.35-.12-.23-.11-.23-.12-.23-.11-.23-.12-.24-.23-.11-.12-.23-.23-.12-.11-.23-.24-.12-.11-.23-.23-.11-.23-.12-.12-.23-.23-.12-.23-.11-.12-.23-.23-.12-.12-.23-.11-.35v-.23l.23-.23.12-.12.46-.23.69-.11H268l.69.11.12.23.58.12h.46l.35-.12.11-.11.24-.23.11-.35.12-.23-.12-.35-.11-.11-.12-.24-.23-.11L270,147l-.23-.12-.23-.11-.35-.12-.34-.12-.93-.11h-.35l-.81.11-.46.12-.23.12-.23.11-.23.12-.24.11-.23.12-.23.23-.23.12-.23.23-.12.11-.11.23-.12.12-.11.23-.12.23v.12l.12,1.73v-.34l.11.57.12.24.23.11v.23l.23.12.12.23.23.12.11.23.35.11.12.24.23.11.23.12.11.23.35.11.12.35.34.12.12.23.12.23.11.35v.46l-.11.23-.58.12h-1l-.58-.12-.23-.11-.24-.24-.23-.11-.11-.23-.23-.35v-.23l-.24-.47-.11-.23-.23-.11-.35-.12h0l-.23-.11-.23.11-.35.12h0l-.12.11h0l-.11.12h0l-.12.11h0v.12l-.11.23Zm8.91-1.73.11,1h0l.12.58.11.23.12.23.12.35.11.23.12.23.11.23.23.12.12.34.23.12.12.23.23.12.11.23.24.11.23.12.11.23.35.12.23.11.23.12.35.11.58.12.58.12h1.85l.46-.12.47-.12.57-.11.23-.12.24-.11.23-.12.11-.23.12-.23v-.47l-.12-.34-.11-.23-.23-.12-.35-.11h0l-.35-.12-.23.12-.58.11-.46.12h-2L275,155l-.35-.11-.23-.12-.12-.23-.23-.12-.11-.23-.23-.12-.12-.23-.23-.11-.12-.23-.11-.35-.12-.23-.11-.7v-.34l.11-.35.12-.23.23-.23.11-.12.24-.23.11-.12.35-.23.11-.11.47-.23h.69l.23.11.47.12.34.11h.35l.35-.11.23-.12.11-.23.12-.35v-.46l-.12-.35-.11-.23-.23-.12-.23-.23-.47-.11-.46-.12-.46-.11h-.93l-.46.11L274,148l-.35.11-.23.23-.23.12-.23.12-.24.23-.23.11-.23.23-.11.12-.24.23-.11.12-.23.23-.12.12-.11.23-.12.11-.12.35L271,151l-.12.34-.11.47Zm9.14-2,.11.69v-.11l.12.34.23.12.23.12.35.11,1,.12.23.11-.11,3.36-.12.69h-.23l-.46.12-.24.11-.23.24-.11.11-.12.12-.11.69.11.12.12.46.34.12.24.11.34.12H282l.35-.12.23-.11h2.78l.34-.23.12-.24.11-.23v-.58l-.23-.34h0v-.12h-.11l-.12-.23-.46-.12-.46-.11-.23-.12v-.46l.11-3.24.7-.12.34-.11.23-.12V151l.23-.24v-.46l-.11-.46-.12-.23-.23-.12-.11-.11-1.16-.24h-.23l-2.78-.23.46.12-.69-.12-.23.12-.35.11h0l-.11.12h0l-.12.12h0l-.12.11h0v.12l-.11.23Zm6,.23.12,2.2v-.69l.12,2.08h0l.11.34h0l.12,2.44v-.7l.11,1v-.23l.12.46.23.12v.23l.35.12.11.23,1,.11h4.4l.35-.23.23-.11.12-.23.11-.35v-.35l-.11-.35-.12-.23-.23-.11-.12-.12-.58-.12-.23.12-1.15-.12h0l-2.55-.23.12-1.27v.12l.34-.12H289l1.85.12.12.11,1.5-.23-.23.12.46-.24.12-.23.11-.34v-.35l-.11-.35-.12-.23-.23-.11-.12-.12-1.38-.12h0l-1.05-.11h0l-.69-.12h0l-.93-.11h-.11l-.12-1.05v.47l.12-.47,1-.23h.12l1.38-.23h.12l.7-.23.23-.11.23-.12.11-.23.12-.35v-.35l-.12-.34-.11-.24-.23-.11-.12-.12-.58-.11-.23.11-.81.12-.69.11-.58.12-.7.12-.46.11-.46.12-.46.11-.24.23-.11.12-.23.23-.12.12-.12.46Zm7.64,1.16.12,6.13v-1.85l.11,2.31v-.34l.12.46H294v.11l.11.24.46.11h.58l.23-.11.23-.12.12-.23.12-.35v-.34l-.12-1.74v-4.4H296l.12.35.23.12.12.34.23.12.11.35.23.11.12.23.12.23.23.12.11.35.23.11.12.23.11.23.24.12.11.46.23.12.12.23.23.12v.23l.23.11v.23l.12.24.11.23.12.23.12.23.23.12v.23l.23.11v.24l.23.11v.23l.35.12.23.11h.58l.34-.11.12-.12.23-.23v-.11l.12-.35.11-.93.12-2.2.11-1.73.12-.81.11-.35.12-.46.12-.93.11-.69V148l-.11-.35-.12-.23-.23-.12-.12-.11-1,.11h0l-.11.12h0l-.12.12h0l-.11.11h0v.12l-.24,1-.11.69-.12.81-.11.35-.12.81-.12.81-.11,1.27-.12-.23-.23-.23-.11-.23-.12-.12-.11-.23-.12-.11-.12-.24-.23-.23-.11-.23-.23-.11-.12-.24-.12-.23-.23-.11-.11-.24-.12-.23-.23-.23-.12-.23-.23-.23-.11-.23-.23-.12-.12-.23-.23-.12-.12-.23-.23-.11-.23-.23-.23-.12h-1.39l-.23.23-.12.12-.23.34-.11.35-.12.35-.12.35-.11.46-.12.58Zm9.72.58.12,1h0l.11.58.12.23.12.23.11.35.12.23.11.23.12.23.23.12.12.34.23.12.11.23.23.12.12.23.23.11.23.12.12.23.35.12.23.11.23.12.35.11.57.12.58.12H310l.47-.12.46-.12.58-.11.23-.12.23-.11.23-.12.12-.23.11-.23v-.47l-.11-.34-.12-.23-.23-.12-.35-.11h0l-.34-.12-.23.12-.58.11-.47.12h-2l-.47-.12-.34-.11-.23-.12-.12-.23-.23-.12-.12-.23-.23-.12-.11-.23-.24-.11-.11-.23-.12-.35-.11-.23-.12-.7v-.34l.12-.35.11-.23.23-.23.12-.12.23-.23.12-.12.34-.23.12-.11.46-.23h.7l.23.11.46.12.35.11h.35l.34-.11.23-.12.12-.23.11-.35v-.46l-.11-.35-.12-.23-.23-.12-.23-.23L309,148l-.46-.12-.47-.11h-.92l-.47.11-.23.12-.34.11-.24.23-.23.12-.23.12-.23.23-.23.11-.23.23-.12.12-.23.23-.12.12-.23.23-.11.12-.12.23-.11.11-.12.35-.12.35-.11.34-.12.47Zm9.14-1.74.12,2.2v-.69l.11,2.08h0l.12.34h0l.12,2.44v-.7l.11,1v-.23l.12.46.23.12v.23l.35.12.11.23,1,.11h4.4l.35-.23.23-.11.12-.23.11-.35v-.35l-.11-.35-.12-.23-.23-.11-.12-.12-.58-.12-.23.12-1.16-.12h0l-2.54-.23.12-1.27v.12l.34-.12h.12l1.85.12.11.11,1.51-.23-.23.12.46-.24.12-.23.11-.34v-.35l-.11-.35-.12-.23-.23-.11-.12-.12-1.39-.12h0l-1-.11h0l-.69-.12h0l-.93-.11h-.11l-.12-1.05v.47l.12-.47,1-.23h.12l1.38-.23h.12l.69-.23.24-.11.23-.12.11-.23.12-.35v-.35l-.12-.34-.11-.24-.23-.11-.12-.12-.58-.11-.23.11-.81.12-.69.11-.58.12-.7.12-.46.11-.46.12-.47.11-.23.23-.11.12-.24.23-.11.12-.12.46Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 12.09,
    height: 2.53,
    x: 211.1,
    y: 299.44,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 0.89
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 15.87,
    height: 3.75,
    x: 209.28,
    y: 335.23,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M80.78,223.38l13.71.45c4.52,5.16,8.49,20.58,12,24.5,4.28-5.92,2.46-25.21,2.46-25.21l3.6-.52a13.61,13.61,0,0,1,7.57.62c1.7.71,10,6.45,17.82,10.23m14.66-.68a31.6,31.6,0,0,0,0-7m-3-15.1,16.25-7.33c5.88,25.65,2.89,52.16-4.5,54.81-5.87,2.11-14.33-.16-22.67-4m-16.65-9.66L121,243.7c.07.62.13,1.24.19,1.86m3,27.81c2.15,19.65,4.3,38.4,6.42,58.62.62,5.94,1.24,12,1.85,18.25-8.16,1.93-16.2,3.52-25.08,2.59-.72-4.76-2-10.81-2.7-15.57l-3.27,14.88c-12.9,2.65-26.52.31-39.71-3.34,0,0,6.84-63,10.67-97.77"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M146.25,212.18a1.91,1.91,0,1,1-1.91,1.91A1.9,1.9,0,0,1,146.25,212.18Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M148,218.27a1,1,0,1,1-1,.95A1,1,0,0,1,148,218.27Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M149.85,215.57a.68.68,0,1,1,0,1.36.68.68,0,0,1,0-1.36Z"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 148.4,
    x2: 148.52,
    y1: 206.99,
    y2: 208.72,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUni);
export default __webpack_public_path__ + "static/media/uni.ef030c2aa2ba18a0c765751a461a2994.svg";
export { ForwardRef as ReactComponent };